import { render, staticRenderFns } from "./ClientContentList.vue?vue&type=template&id=63b0cb71&scoped=true&"
import script from "./ClientContentList.vue?vue&type=script&lang=js&"
export * from "./ClientContentList.vue?vue&type=script&lang=js&"
import style0 from "./ClientContentList.vue?vue&type=style&index=0&id=63b0cb71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0cb71",
  null
  
)

export default component.exports